import toggleFlashlight from 'app/_shared/events/camera/toggleFlashlight'
import processScannedCode from 'app/camera/event/processScannedCode'

export default {
  onClick: {
    toggleFlashlight,
  },
  onScan: {
    processScannedCode,
  },
}
